<template>
<!-- 配置-抽成配置-订单模式抽成-编辑 -->

    <el-drawer title="司机抽成配置编辑" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="150px" style="height: 90vh; overflow-y: auto">
                   
                  
                   
                    <div style="margin-left:79px;font-weight:700;margin-top:10px;margin-bottom:10px">全职司机:</div>
                    
                    <el-form-item label="扣除固定金额:">
                        <el-input
                            v-model="submit_data.mode_amount"
                            :placeholder="submit_rules.mode_amount.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >元
                    </el-form-item>
                    <el-form-item label="扣除订单金额百分比:">
                        <el-input
                            v-model="submit_data.mode_rate"
                            :placeholder="submit_rules.mode_rate.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >%
                    </el-form-item>
                    <div style="margin-left:79px;font-weight:700;margin-top:10px;margin-bottom:10px">兼职司机:</div>
                    
                    <el-form-item label="扣除固定金额:">
                        <el-input
                            v-model="submit_data.part_mode_amount"
                            :placeholder="submit_rules.part_mode_amount.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >元
                    </el-form-item>
                    <el-form-item label="扣除订单金额百分比:">
                        <el-input
                            v-model="submit_data.part_mode_rate"
                            :placeholder="submit_rules.part_mode_rate.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >%
                    </el-form-item>

                    <div style="margin-left:79px;font-weight:700;margin-top:10px;margin-bottom:10px">按单司机:</div>
                    
                    <el-form-item label="扣除固定金额:">
                        <el-input
                            v-model="submit_data.single_mode_amount"
                            :placeholder="submit_rules.single_mode_amount.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >元
                    </el-form-item>
                    <el-form-item label="扣除订单金额百分比:">
                        <el-input
                            v-model="submit_data.single_mode_rate"
                            :placeholder="submit_rules.single_mode_rate.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input
                        >%
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="false"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>
<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.submit_data.order_mode_code = _this.data;
            // console.log(_this.submit_data.order_mode_code, '_this.submit_data.order_mode_code');
            _this.orderModeDeductionDetails();
        }
    },
    data() {
        return {
            show: false,
            submit_url: '/order/editOrderModeDeductionSubmit',
            // 编辑页面表单数据
            submit_data: {
                order_mode_code: '',
                mode_amount: '',
                part_mode_amount: '',
                single_mode_amount: '',
                mode_rate: '',
                part_mode_rate: '',
                single_mode_rate: ''
            },
            // 编辑页面表单验证规则
            submit_rules: {
                mode_amount: {
                    placeholder: '扣除固定金额',
                    rules: {
                        required: true,
                        message: '扣除固定金额为不小于0的数字',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                part_mode_amount: {
                    placeholder: '扣除固定金额',
                    rules: {
                        required: true,
                        message: '扣除固定金额为不小于0的数字',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                single_mode_amount: {
                    placeholder: '扣除固定金额',
                    rules: {
                        required: true,
                        message: '扣除固定金额为不小于0的数字',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                mode_rate: {
                    placeholder: '扣除订单金额百分比',
                    rules: {
                        required: true,
                        message: '扣除订单金额百分比为不小于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                part_mode_rate: {
                    placeholder: '扣除订单金额百分比',
                    rules: {
                        required: true,
                        message: '扣除订单金额百分比为不小于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                single_mode_rate: {
                    placeholder: '扣除订单金额百分比',
                    rules: {
                        required: true,
                        message: '扣除订单金额百分比为不小于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 提交
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;

            //点击关闭按钮触发的方法，重置编辑页面表单数据
            _this.submit_data = {
                order_mode_code: '',
                mode_amount: '',
                part_mode_amount: '',
                single_mode_amount: '',
                mode_rate: '',
                part_mode_rate: '',
                single_mode_rate: '',
            };
        },
        //商家详情
        orderModeDeductionDetails() {
            _this
                .$post('/order/orderModeDeductionDetails', {
                    order_mode_code: _this.submit_data.order_mode_code
                })
                .then((res) => {
                    _this.submit_data.mode_amount = res.data.mode_amount;
                    _this.submit_data.part_mode_amount = res.data.part_mode_amount;
                    _this.submit_data.single_mode_amount = res.data.single_mode_amount;
                    _this.submit_data.mode_rate = res.data.mode_rate;
                    _this.submit_data.part_mode_rate = res.data.part_mode_rate;
                    _this.submit_data.single_mode_rate = res.data.single_mode_rate;
                })
                .catch((err) => {});
        }
    }
};
</script>
<style scoped>

</style>